import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import md5 from 'md5';
import { ChevronDownIcon } from 'lucide-react';

const Header = ({ category, title, setIsAuthenticated }) => {
  const [admin, setAdmin] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    // load from the keys you actually have:
    const email = localStorage.getItem('adminEmail');
    const id    = localStorage.getItem('adminId');
    if (email && id) {
      setAdmin({
        email,
        // fallback display name = part before @
        name: email.split('@')[0],
        id
      });
      // restore auth header too
      const token = localStorage.getItem('admintoken');
      if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('admintoken');
    localStorage.removeItem('adminEmail');
    localStorage.removeItem('adminId');
    delete axios.defaults.headers.common['Authorization'];
    setIsAuthenticated(false);
    navigate('/login');
  };

  // generate Gravtar from the real email:
  const gravatarUrl = admin
    ? `https://www.gravatar.com/avatar/${md5(
        admin.email.trim().toLowerCase()
      )}?s=40&d=identicon`
    : `https://www.gravatar.com/avatar/?d=mp&s=40`;

  return (
    <div className="sticky top-0 z-50 bg-white dark:bg-gray-900 flex items-center justify-between px-4 py-2 shadow-sm">
      <div>
        <img src='l2.svg' alt="Logo" className="h-10" />
      </div>

      {admin && (
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(o => !o)}
            className="flex items-center space-x-2 focus:outline-none"
          >
            <img
              src={gravatarUrl}
              alt="avatar"
              className="w-8 rounded-full"
            />
            <span className="font-medium text-slate-900 dark:text-white">
              {admin.name}
            </span>
            <ChevronDownIcon className="w-4 h-4 text-gray-500 dark:text-gray-400 flex items-center" />
          </button>

          {dropdownOpen && (
            <ul className="absolute right-0 mt-2 w-36 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded shadow-md">
              <li>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  Logout
                </button>
              </li>
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;